import { defineMessages } from 'react-intl';

export default defineMessages({
  submitModalRemarksTite: {
    id: 'submitModal.remarks.title',
    defaultMessage: 'Remarks',
  },
});
